import { formatDateToDDMMYYYY } from 'src/app/project/shared/date-utils';
import { splitYearIntoWeeks } from './split-year-into-weeks';

export function getWeekFormattedTimeframes(from: Date, to: Date): string[] {
  let elements = [];

  const weeks = splitYearIntoWeeks(from, to);

  weeks.forEach((_week) => {
    const date = _week[1];

    const formattedDate = formatDateToDDMMYYYY(date);
    elements = [...elements, formattedDate];
  });

  return elements;
}
